import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TooltipOptions } from 'chart.js';

@Component({
  selector: 'ui-fh-button',
  templateUrl: './fh-button.component.html',
  styleUrls: ['./fh-button.component.scss']
})
export class FhButtonComponent implements OnInit {
  @Input() label: string = '';
  @Input() tooltip: string = '';
  @Input() tooltipPosition: 'right' | 'left' | 'top' | 'bottom' | string | undefined = 'bottom';
  @Input() chosenType: string = '';
  @Input() class: string = '';
  @Input() outerClass: string = '';
  @Input() disabled: boolean = false;
  @Input() withBorder: boolean = false;
  @Input() loading: boolean = false;
  @Input() icon: string = '';
  @Input() size: 'small' | 'large' | undefined = undefined;
  @Input() iconPos: 'left' | 'right' | 'top' | 'bottom' = 'right';
  @Input() severity: 'success' | 'info' | 'warning' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast' = 'primary';
  @Input() outline: boolean = false;
  @Input() locked: boolean = false;
  @Input() badge: string | undefined;
  @Input() badgeClass: string | undefined;
  @Output() clickEvent: EventEmitter<any> = new EventEmitter();
  computedClass: string = '';
  timeLeft = 5;

  ngOnInit(): void {
    this.computeClasses();
    this.setTimer();
  }

  ngOnChanges(): void {
    this.computeClasses();
  }

  private computeClasses(): void {
    this.computedClass = `${this.class.trim()} ${this.withBorder ? 'p-button-with-border' : ''}`.trim();
  }

  onClick() {
    this.clickEvent.emit();
  }

  setTimer(): void {
    const timer = window.setInterval(() => {
      if (this.timeLeft === 1) {
        clearInterval(timer);
        this.locked = false;
        return;
      }
      this.timeLeft--;
    }, 1000);
  }
}
